import produce from "immer";
import { LoadState } from "../../../constants/enums";
import { initialLeadAutoApplicationState } from "./leadAutoApplicationState";
import {
  CLEAR_LEAD_AUTO_APPLICATION_STATE,
  FETCH_LEAD_AUTO_APPLICATION_FAILED,
  FETCH_LEAD_AUTO_APPLICATION_PROGRESS,
  FETCH_LEAD_AUTO_APPLICATION_SUCCESS,
} from "./leadAutoApplicationActions";
import { ILeadAutoApplicationState } from "./leadAutoApplication.types";
import { IAutomobileApplication } from "../../automobileApplication/automobileApplication.types";
import { IAutomobileAlbertaApplication } from "../../automobileAlbertaApplication/automobileAlbertaApplication.types";

export const leadAutoApplicationReducer = (
  state: ILeadAutoApplicationState = initialLeadAutoApplicationState,
  action: any
): ILeadAutoApplicationState => {
  switch (action.type) {
    case FETCH_LEAD_AUTO_APPLICATION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_LEAD_AUTO_APPLICATION_SUCCESS: {
      const { data, subType } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.activeSubType = subType;
        if (subType === "ab") {
          draftState.data_ab = data as IAutomobileAlbertaApplication;
        } else {
          draftState.data_on = data as IAutomobileApplication;
        }
      });
      return newState;
    }
    case FETCH_LEAD_AUTO_APPLICATION_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_LEAD_AUTO_APPLICATION_STATE: {
      return initialLeadAutoApplicationState;
    }
    default: {
      return state;
    }
  }
};
